"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ let TranslationKey = exports.TranslationKey = /*#__PURE__*/ function(TranslationKey) {
    TranslationKey["addBtn"] = "addBtn";
    TranslationKey["addProductsToBag"] = "addProductsToBag";
    TranslationKey["addProductsToBagSuccessMsg"] = "addProductsToBagSuccessMsg";
    TranslationKey["addProductsToBagSuccessTitle"] = "addProductsToBagSuccessTitle";
    TranslationKey["backBtn"] = "backBtn";
    TranslationKey["cancel"] = "cancel";
    TranslationKey["clearSearchField"] = "clearSearchField";
    TranslationKey["closeAddProductsToBagSuccessDialog"] = "closeAddProductsToBagSuccessDialog";
    TranslationKey["copyToClipboardBtn"] = "copyToClipboardBtn";
    TranslationKey["copyToClipboardTooltip"] = "copyToClipboardTooltip";
    TranslationKey["createAList"] = "createAList";
    TranslationKey["deleteIconLabel"] = "deleteIconLabel";
    TranslationKey["deletionDialogCancelBtn"] = "deletionDialogCancelBtn";
    TranslationKey["deletionDialogOkBtn"] = "deletionDialogOkBtn";
    TranslationKey["deletionDialogText"] = "deletionDialogText";
    TranslationKey["deletionDialogTitle"] = "deletionDialogTitle";
    TranslationKey["editList"] = "editList";
    TranslationKey["goToBasket"] = "goToBasket";
    TranslationKey["linkHere"] = "linkHere";
    TranslationKey["listNameDescription"] = "listNameDescription";
    TranslationKey["listNameTitle"] = "listNameTitle";
    TranslationKey["maxListDlgBackBtn"] = "maxListDlgBackBtn";
    TranslationKey["maxPrivateDlgSaveBtn"] = "maxPrivateDlgSaveBtn";
    TranslationKey["maxPrivateDlgText"] = "maxPrivateDlgText";
    TranslationKey["maxPrivateDlgTitle"] = "maxPrivateDlgTitle";
    TranslationKey["maxPublicDlgSaveBtn"] = "maxPublicDlgSaveBtn";
    TranslationKey["maxPublicDlgText"] = "maxPublicDlgText";
    TranslationKey["maxPublicDlgTitle"] = "maxPublicDlgTitle";
    TranslationKey["personalBeautyStoreLink"] = "personalBeautyStoreLink";
    TranslationKey["personalProductsListDetailTitle"] = "personalProductsListDetailTitle";
    TranslationKey["privateSwitchLabel"] = "privateSwitchLabel";
    TranslationKey["privateSwitchTooltipText"] = "privateSwitchTooltipText";
    TranslationKey["privateSwitchTooltipTitle"] = "privateSwitchTooltipTitle";
    TranslationKey["productListDetailDescription"] = "productListDetailDescription";
    TranslationKey["productListDetailPageTitle"] = "productListDetailPageTitle";
    TranslationKey["productListOverviewEmptyListMessage"] = "productListOverviewEmptyListMessage";
    TranslationKey["productListOverviewPageDescription"] = "productListOverviewPageDescription";
    TranslationKey["productListOverviewPageTitle"] = "productListOverviewPageTitle";
    TranslationKey["productNumber"] = "productNumber";
    TranslationKey["saveList"] = "saveList";
    TranslationKey["saveListBtn"] = "saveListBtn";
    TranslationKey["searchBtn"] = "searchBtn";
    TranslationKey["searchDefaultText"] = "searchDefaultText";
    TranslationKey["searchDialogLinkName"] = "searchDialogLinkName";
    TranslationKey["searchDialogName"] = "searchDialogName";
    TranslationKey["sharingLinkButtonDescription"] = "sharingLinkButtonDescription";
    TranslationKey["sorryMsgText"] = "sorryMsgText";
    TranslationKey["sorryMsgTitle"] = "sorryMsgTitle";
    TranslationKey["youDontHaveAnyList"] = "youDontHaveAnyList";
    TranslationKey["yourList"] = "yourList";
    return TranslationKey;
}({});
